import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { BaseApiService } from './base-api.service';
import { MappingFieldsRequestParamDto } from '../../dto';

@Injectable({
    providedIn: 'root',
})
export class ZohoApiService {
    private readonly url: string = 'service/contactcloud/zoho';

    constructor(
        private readonly baseApiService: BaseApiService
    ) { }

    authenticate(code: string, accounts_server: string): Observable<any> {
        return this.baseApiService.post('zoho/authenticate', {}, { params: { code, 'accounts-server': accounts_server } });
    }

    refreshToken(): any {
        return this.baseApiService.post(`zoho/refreshToken`);
    }

    logout(): any {
        return this.baseApiService.post(`zoho/logout`);
    }

    getSettings(): Observable<any> {
        return this.baseApiService.get(`${this.url}/settings`);
    }

    getMappingFields(params: MappingFieldsRequestParamDto = {}): Observable<any> {
        const requestParams = params.isAutomation ? { is_automation: true } : {};
        return this.baseApiService.get(`${this.url}/fields`, { params: requestParams });
    }

    updateSettings(settings): Observable<any> {
        return this.baseApiService.put(`${this.url}/settings`, settings);
    }

    loadLeadOwners() {
        return this.baseApiService.get(`${this.url}/leadOwners`);
    }

    loadCampaigns() {
        return this.baseApiService.get(`${this.url}/campaigns`);
    }

    validateDuplicates(export_type: string, ids: number[], icpintel_job_uuid: string) {
        return this.baseApiService.post(`${this.url}/duplicate`, {
            export_type,
            icpintel_job_uuid,
            ids
        });
    }

    export(export_type: string, lead_owner: number, campaigns: number[], duplicate_resolution: string, ids: number[], icpintel_job_uuid: string) {
        return this.baseApiService.post(`${this.url}/export`, {
            duplicate_resolution: duplicate_resolution === 'skip' ? '' : duplicate_resolution,
            export_type,
            lead_owner,
            campaigns,
            icpintel_job_uuid,
            ids
        });
    }

    validateCompaniesDuplicates(requestBody) {
        return this.baseApiService.post(`${this.url}/companies/duplicate`, requestBody);
    }

    exportCompany(requestBody) {
        return this.baseApiService.post(`${this.url}/companies/export`, requestBody);
    }

    validateMapping() {
        return this.baseApiService.get(`${this.url}/validateMapping`);
    }
}
